import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { InputNumber, Modal, Space } from 'antd'

// "Remind me in N days" (spec: 0042_growth_bot Req 2.3). Default 7, like the Telegram button.
const RemindModal = ({ record, onCancel, onConfirm }) => {
  const [days, setDays] = useState(7)

  useEffect(() => {
    if (record) setDays(7)
  }, [record])

  return (
    <Modal
      title={record ? `Remind me about ${record.name}` : 'Remind me'}
      open={Boolean(record)}
      okText="Remind me"
      onOk={() => onConfirm(days || 7)}
      onCancel={onCancel}
      centered
    >
      <Space>
        In
        <InputNumber min={1} max={365} value={days} onChange={setDays} />
        days
      </Space>
    </Modal>
  )
}

RemindModal.propTypes = {
  record: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default RemindModal
